import { SlSocialFacebook as FacebookIcon } from 'react-icons/sl';
import { SiWhatsapp as WhatsappIcon } from 'react-icons/si';
import { SiInstagram as InstagramIcon } from 'react-icons/si';
import { BsTiktok as TiktokIcon } from 'react-icons/bs';
import { Mail } from 'lucide-react';

const icons = {
  FacebookIcon,
  WhatsappIcon,
  InstagramIcon,
  TiktokIcon,
  Mail,
};

export default icons;
